import PropTypes from 'prop-types';
import React, { useState } from 'react';

const DeleteIcon = ({ theme }) => {
  const [color, setColor] = useState('#66737E');

  return (
    <svg
      fill="none"
      height="26"
      onMouseOut={() => {
        setColor('#66737E');
      }}
      onMouseOver={() => {
        if (theme === 'ak529') {
          setColor('#520F9A');
        } else if (theme === 'md529') {
          setColor('#ED8B00');
        } else {
          setColor('#006894');
        }
      }}
      viewBox="0 0 26 26"
      width="26"
    >
      <path
        d="M22 5.5L20.188 22.709C20.0811 23.7267 19.2233 24.4995 18.2 24.5H7.8C6.77636 24.5 5.91797 23.727 5.811 22.709L4 5.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M1.5 5.5H24.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.5 5.5V2.5C8.5 1.94772 8.94772 1.5 9.5 1.5H16.5C17.0523 1.5 17.5 1.94772 17.5 2.5V5.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13 10V20.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17.5 10L17 20.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.5 10L9 20.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

DeleteIcon.propTypes = {
  theme: PropTypes.string
};

export default DeleteIcon;
